import type {
  Layout,
  Proportions,
} from 'hb-builder/components/common/Wrapper/components/DynamicLayoutToolbar';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

export const getIsLayoutSelected = ({
  item,
  layout,
  proportions,
}: {
  item: DocumentItem;
  layout: Layout;
  proportions?: Proportions;
}): boolean =>
  // For all cases besides 2 column layouts
  item.children?.length === layout &&
  (!proportions ||
    // For 2 column layouts,
    // for each proportion we need to find out wether we have a matching children or not,
    // if all proportions have a matching child, it means it's the currently selected layout
    proportions.reduce((result, proportion, index) => {
      const matchingChild =
        item.children?.[index].attributes?.width === proportion * 100;

      return result && matchingChild;
    }, true));
